module.exports = __webpack_public_path__ + "img/5163a57.png";